import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "auth-main-wrapper col-lg-5 col-md-6 col-sm-12 mt-5" }
const _hoisted_2 = { class: "auth-inner-div w-100 text-center" }
const _hoisted_3 = { class: "auth-header" }
const _hoisted_4 = { class: "auth-inner-form-div" }
const _hoisted_5 = { class: "auth-input d-flex align-content-center checkbox" }
const _hoisted_6 = { for: "company_registration" }
const _hoisted_7 = { class: "auth-input" }
const _hoisted_8 = { class: "auth-input pt-0" }
const _hoisted_9 = {
  key: 0,
  class: "auth-input pt-0"
}
const _hoisted_10 = { class: "auth-inner-div w-100 pt-4" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = {
  key: 0,
  class: "customer-loader"
}
const _hoisted_14 = { class: "auth-inner-div auth-bottom-sentence w-100 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBoxComponent = _resolveComponent("CheckBoxComponent")!
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('registration')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_CheckBoxComponent, {
          id: "company_registration",
          name: "company_registration",
          onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.form.isCompany = !_ctx.form.isCompany))
        }, {
          "checkbox-text": _withCtx(() => [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('company_registration')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.inputs, (input) => {
          return (_openBlock(), _createBlock(_component_InputComponent, {
            class: "w-100 mx-auto",
            "name-input": input.name,
            "data-type": input.dataType,
            placeholder: _ctx.$t(input.placeholder),
            data: input.value,
            "onUpdate:data": ($event: any) => ((input.value) = $event),
            msg: input.validation
          }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.customerInputs, (input) => {
          return (_openBlock(), _createBlock(_component_InputComponent, {
            class: "w-100 mx-auto",
            "name-input": input.name,
            "data-type": input.dataType,
            placeholder: _ctx.$t(input.placeholder),
            data: input.value,
            "onUpdate:data": ($event: any) => ((input.value) = $event),
            msg: input.validation
          }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"]))
        }), 256))
      ]),
      (_ctx.form.isCompany)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.companyInputs, (input) => {
              return (_openBlock(), _createBlock(_component_InputComponent, {
                class: "w-100 mx-auto",
                "name-input": input.name,
                "data-type": input.dataType,
                placeholder: _ctx.$t(input.placeholder),
                data: input.value,
                "onUpdate:data": ($event: any) => ((input.value) = $event),
                msg: input.validation
              }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: _normalizeClass(["auth-customer-login-button w-100", {'less-padding-07': _ctx.loading}]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"])),
        disabled: _ctx.loading
      }, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('register')), 1),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13))
          : _createCommentVNode("", true)
      ], 10, _hoisted_11)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createTextVNode(_toDisplayString(_ctx.$t('have_an_account') + ' ') + " ", 1),
      _createVNode(_component_router_link, {
        class: "blue",
        to: "/login"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('login')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}